import { gql } from '@apollo/client';

export const BOOKMARK_FOLDER_FRAGMENT = gql`
  fragment BookmarkFolder on Document {
    key
    name
  }
`;